var map = {
	"./act": 1496,
	"./act.tsx": 1496,
	"./gmat": 1497,
	"./gmat.tsx": 1497,
	"./gre": 1498,
	"./gre.tsx": 1498,
	"./ielts": 1499,
	"./ielts.tsx": 1499,
	"./ielts_general_training": 1500,
	"./ielts_general_training.tsx": 1500,
	"./lsat": 1501,
	"./lsat.tsx": 1501,
	"./mcat": 1502,
	"./mcat.tsx": 1502,
	"./sat": 1503,
	"./sat.tsx": 1503,
	"./toefl": 1504,
	"./toefl.tsx": 1504
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2515;
module.exports = webpackAsyncContext;